export const AUDIO_CLIP_MODAL_TITLE = 'Select a new clip';
